import profile from '../../Assets/Images/Artists/07/profile_hidden.jpg'
import projectOneImg1 from '../../Assets/Images/Artists/07/projects/01/1.jpg'
import projectOneImg2 from '../../Assets/Images/Artists/07/projects/01/2.jpg'
import projectOneImg3 from '../../Assets/Images/Artists/07/projects/01/3.jpg'
import projectOneImg4 from '../../Assets/Images/Artists/07/projects/01/4.jpg'
import projectOneImg5 from '../../Assets/Images/Artists/07/projects/01/5.jpg'
import projectOneImg6 from '../../Assets/Images/Artists/07/projects/01/6.jpg'
import projectOneImg7 from '../../Assets/Images/Artists/07/projects/01/7.jpg'
import projectOneImg8 from '../../Assets/Images/Artists/07/projects/01/8.jpg'
import projectOneImg9 from '../../Assets/Images/Artists/07/projects/01/9.jpg'
import projectOneImg10 from '../../Assets/Images/Artists/07/projects/01/6.jpg'

const projectOneImages = [
  projectOneImg1,
  projectOneImg2,
  projectOneImg3,
  projectOneImg4,
  projectOneImg5,
  projectOneImg6,
  projectOneImg7,
  projectOneImg8,
  projectOneImg9,
  projectOneImg10,
]

const project1 = {
  title: '3D Shots',
  year: 2017,
  content: [
    {
      type: 'image',
      images: [...projectOneImages]
    }
  ]
}

const projects = [
  project1,
]

const user = {
  username: 'tlrp',
  name: 'Taylor-peter A.',
  url: 'https://www.instagram.com/arrontp/',
  avatar: profile,
  seen: false,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/tlrp.js